import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_DISTRIBUTIONS_LIST,
  GET_DISTRIBUTIONS_LIST_SUCCESS,
  GET_DISTRIBUTIONS_LIST_ERROR,
  GET_DISTRIBUTION,
  GET_DISTRIBUTION_SUCCESS,
  GET_DISTRIBUTION_ERROR,
  ADD_DISTRIBUTION,
  ADD_DISTRIBUTION_SUCCESS,
  ADD_DISTRIBUTION_ERROR,
  UPDATE_DISTRIBUTION,
  UPDATE_DISTRIBUTION_SUCCESS,
  UPDATE_DISTRIBUTION_ERROR,
  DELETE_DISTRIBUTION,
  DELETE_DISTRIBUTION_SUCCESS,
  DELETE_DISTRIBUTION_ERROR,
  GET_DISTRIBUTION_ARCHIVE,
  GET_DISTRIBUTION_ARCHIVE_SUCCESS,
  GET_DISTRIBUTION_ARCHIVE_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/distribution';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.distribution;
const distribution = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullDistribution') {
        return {
          ...state,
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'currentDistribution':
          key = 'current';
          break;
        case 'addDistribution':
          key = 'add';
          break;
        case 'updateDistribution':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case GET_DISTRIBUTIONS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_DISTRIBUTIONS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_DISTRIBUTIONS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // GET
    case GET_DISTRIBUTION:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DISTRIBUTION_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // ADD
    case ADD_DISTRIBUTION:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
        },
      };
    case ADD_DISTRIBUTION_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: action.error,
        },
      };
    case ADD_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // UPDATE
    case UPDATE_DISTRIBUTION:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_DISTRIBUTION_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // DELETE
    case DELETE_DISTRIBUTION:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_DISTRIBUTION_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // GET DISTRIBUTION ARCHIVE
    case GET_DISTRIBUTION_ARCHIVE:
      return {
        ...state,
        archive: {
          ...state.archive,
          error: null,
          done: false,
        },
      };
    case GET_DISTRIBUTION_ARCHIVE_ERROR:
      return {
        ...state,
        archive: {
          ...state.archive,
          error: action.error,
        },
      };
    case GET_DISTRIBUTION_ARCHIVE_SUCCESS:
      return {
        ...state,
        archive: {
          ...state.archive,
          error: null,
          done: true,
        },
      };
    default:
      return state;
  }
};

export default distribution;



// WEBPACK FOOTER //
// ./reducers/updates/distribution.js